module.exports = __webpack_public_path__ + "img/move-icon.1fa51cfe.png";